import React from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase/config";
const Footer = () => {
    const trackButtonClick = (buttonName, location, additionalParams = {}) => {
        logEvent(analytics, "button_click", {
          button_name: buttonName,
          location: location,
          ...additionalParams
        });
      };
    
      const trackNavigation = (destination, location) => {
        logEvent(analytics, "navigation", {
          destination: destination,
          location: location
        });
      };
    
      const trackPromoClick = (promoName, location) => {
        logEvent(analytics, "promotion_click", {
          promotion_name: promoName,
          location: location
        });
      };
    
      const trackResourceClick = (resourceName, resourceType, location) => {
        logEvent(analytics, "resource_click", {
          resource_name: resourceName,
          resource_type: resourceType,
          location: location
        });
      };
    
      const trackTestimonialClick = (testimonial, location) => {
        logEvent(analytics, "testimonial_click", {
          student_name: testimonial.name,
          university: testimonial.university,
          score: testimonial.score,
          location: location
        });
      };
    
      const trackContactClick = (contactType, contactValue) => {
        logEvent(analytics, "contact_click", {
          contact_type: contactType,
          contact_value: contactValue,
          location: "footer"
        });
      };
    return(
        <>

<footer className="footer">
        <p>&copy; {new Date().getFullYear()} TOEFL Top. All rights reserved.</p>
        <p>
          <span 
            onClick={() => trackContactClick("email", "amit@careerclaw.com")}
          >
            amit@careerclaw.com
          </span>
          {" | "}
          <span 
            onClick={() => trackContactClick("phone", "+1 (814) 321-2586")}
          >
            +1 (814) 321-2586
          </span>
        </p>
        <div style={{ marginTop: "1rem" }}>
          {["facebook", "twitter", "instagram"].map((social) => (
            <a
              key={social}
              href={`#${social}`}
              className="footer-link"
              onClick={() => trackButtonClick(
                social,
                "footer_social",
                { platform: social }
              )}
            >
              {social.charAt(0).toUpperCase() + social.slice(1)}
            </a>
          ))}
        </div>
      </footer>
    </>

  );
};

export default Footer;
